module.exports = __webpack_public_path__ + "img/background02.44cb02a5.jpg";